import React from 'react';
import styles from './Home.module.css';
import Hero from '../Hero';
import HomeAbout from '../HomeAbout';
import HomeServices from '../HomeServices';
import CTASection from '../CTASection';

const Home = () => {
  return (
    <div className={styles.home}>
      <Hero />
      <HomeAbout />
      <HomeServices />
      <CTASection />
    </div>
  );
};

export default Home;